import { z } from 'zod';

import { request } from '@/api/httpClient';

const schema = z.object({
  id: z.number().int().positive(),
  message: z.string(),
  user_id: z.number().int().positive().nullable().optional(),
  client_id: z.number().int().positive().nullable().optional(),
  expires_at: z.string().nullable().optional(),
  created_at: z.string(),
  expired: z.boolean(),
});
export type DashboardMessage = z.infer<typeof schema>;
export async function getDashboardMessages() {
  return z.array(schema).parse(await request<unknown>('/managers/technicians-dashboard'));
}
export async function createDashboardMessage(value: {
  message: string;
  userId: number | null;
  clientId: number | null;
  expiresAt: string | null;
}) {
  await request('/managers/technicians-dashboard', {
    method: 'POST',
    body: {
      message: value.message,
      user_id: value.userId,
      client_id: value.clientId,
      expires_at: value.expiresAt,
    },
  });
}
